"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginJourneyRenderingPage = exports.LocalizablePluginJourneyRenderingPage = void 0;
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var JourneyManager_1 = require("../services/JourneyManager");
var journey_services_1 = require("@athena-portal/journey-services");
var QuestionList_1 = require("../widgets/QuestionList");
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var react_intl_1 = require("react-intl");
var operators_1 = require("rxjs/operators");
/**
 * Example page
 */
var PluginJourneyRenderingPage = /** @class */ (function (_super) {
    __extends(PluginJourneyRenderingPage, _super);
    function PluginJourneyRenderingPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            journey: undefined,
            page: undefined,
            product: "",
            process: "",
            serviceError: false,
            journeyLoaded: false,
            interaction: {},
            initialInteraction: {},
            validations: {},
            pageValidations: [],
            showOverlay: false,
            journeyState: {},
            typingTimeout: process.env.REACT_APP_INTERACTION_UPDATE_TIMEOUT ? parseInt(process.env.REACT_APP_INTERACTION_UPDATE_TIMEOUT, 10) : 0
        };
        _this.handleStateChange = _this.handleStateChange.bind(_this);
        _this.handleValidation = _this.handleValidation.bind(_this);
        _this.navigate = _this.navigate.bind(_this);
        _this.setUserReference = _this.setUserReference.bind(_this);
        _this.setJourneyState = _this.setJourneyState.bind(_this);
        _this.getJourneyState = _this.getJourneyState.bind(_this);
        _this.handleImmediateStateChange = _this.handleImmediateStateChange.bind(_this);
        _this.trackChangesAndUpdateInteraction = _this.trackChangesAndUpdateInteraction.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    Object.defineProperty(PluginJourneyRenderingPage.prototype, "pageContext", {
        get: function () {
            return Object.assign(this.state, {
                engine: this
            });
        },
        enumerable: false,
        configurable: true
    });
    PluginJourneyRenderingPage.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        return __awaiter(this, void 0, void 0, function () {
            var prevParams, newParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        document.addEventListener("keydown", this.handleKeyDown);
                        prevParams = prevProps.match.params;
                        newParams = this.props.match.params;
                        if (!(prevParams["product"] !== newParams["product"] ||
                            prevParams["process"] !== newParams["process"] ||
                            (prevParams["interactionId"] && !newParams["interactionId"]))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadJourney()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(prevProps.intl.locale !== this.props.intl.locale)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.switchLanguage(this.props.intl.locale)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.props.location !== prevProps.location) {
                            window.scrollTo(0, 0);
                        }
                        if (!(!prevState.page || prevState.page.pageId !== this.state.page.pageId)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.executeOnLoadEvents()];
                    case 5:
                        _a.sent();
                        this.unmountLeaveAlert();
                        this.mountLeaveAlert();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.setJourneyState = function (journeyState) {
        var oldState = this.state.journeyState;
        for (var _i = 0, _a = Object.keys(journeyState); _i < _a.length; _i++) {
            var key = _a[_i];
            oldState[key] = journeyState[key];
        }
        this.setState({
            journeyState: oldState
        });
    };
    PluginJourneyRenderingPage.prototype.getJourneyState = function () {
        return this.state.journeyState;
    };
    /**
     * Component mounted - load dynamic data
     */
    PluginJourneyRenderingPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadJourney()];
                    case 1:
                        _a.sent();
                        window.onpopstate = function (event) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        event.preventDefault();
                                        if (!(this.state.page && this.state.page.prevPage)) return [3 /*break*/, 5];
                                        window.scrollTo(0, 0);
                                        return [4 /*yield*/, this.commandsExecutor.executePageEvent("onBeforeMoveBack", this.pageContext)];
                                    case 1:
                                        _a.sent();
                                        if (!(typeof this.state.page.prevPage === "string")) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.navigate(this.state.page.prevPage, false)];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 5];
                                    case 3: return [4 /*yield*/, this.commandsExecutor.executeCommands({ type: "onPrevPageNavigate" }, this.state.page.prevPage, this.pageContext)];
                                    case 4:
                                        _a.sent();
                                        _a.label = 5;
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); };
                        this.journeySub = this.rendererServices
                            .subscribeToJourney(function (journey) {
                            var page = _this.decidePageToRender(journey);
                            _this.setState({
                                journey: journey,
                                page: page
                            });
                        });
                        this.interactionSub = this.rendererServices
                            .subscribeToInteraction(function (interaction) { return _this.setState({ interaction: interaction }); });
                        this.commandsSub = this.rendererServices
                            .subscribeToCommands(function (commandAndEvent) {
                            _this.commandsExecutor.executeCommands(commandAndEvent.event, commandAndEvent.commands, _this.pageContext);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.unmountLeaveAlert();
                window.onpopstate = function () { return undefined; };
                this.journeySub && this.journeySub.unsubscribe();
                this.interactionSub && this.interactionSub.unsubscribe();
                this.commandsSub && this.commandsSub.unsubscribe();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Renders the page
     */
    PluginJourneyRenderingPage.prototype.render = function () {
        if (this.authorizationRequired()) {
            return (React.createElement(components_1.Authorize, { authorizedHook: this.setUserReference }, this.renderJourney()));
        }
        else {
            return this.renderJourney();
        }
    };
    /**
     * Renders the journey
     */
    PluginJourneyRenderingPage.prototype.renderJourney = function () {
        var _a = this.state, serviceError = _a.serviceError, page = _a.page, journeyLoaded = _a.journeyLoaded, journey = _a.journey, showOverlay = _a.showOverlay;
        if (page) {
            document.title = page.title;
        }
        var autoComplete = journey && (journey.autoComplete === undefined || journey.autoComplete) ? "on" : "off";
        return (React.createElement(React.Fragment, null,
            journeyLoaded && page && (React.createElement("form", { className: "journeyForm", autoComplete: autoComplete, onSubmit: this.handleSubmit }, this.renderLayout())),
            this.renderJourneyLoader(journeyLoaded, serviceError),
            React.createElement(components_1.FormattedMessage, { id: "plugin.pluginJourney.errors.service", defaultMessage: "Service error" }, function (error) { return React.createElement(components_1.ErrorAlert, { show: serviceError, message: error }); }),
            React.createElement(components_1.Overlay, { show: showOverlay }),
            this.rendererServices.renderAddon()));
    };
    /**
     * Validate all questions within a page
     */
    PluginJourneyRenderingPage.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, validationFailures, _i, _a, question, validationResult;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // Trigger event
                    return [4 /*yield*/, this.commandsExecutor.executePageEvent("onBeforeValidate", this.pageContext)];
                    case 1:
                        // Trigger event
                        _b.sent();
                        return [4 /*yield*/, this.commandsExecutor.executeJourneyEvent("onBeforeValidate", this.pageContext)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.pageValidator.validate(this.pageContext.interaction, {
                                journey: this.pageContext.journey,
                                page: this.pageContext.page,
                                engine: this
                            })];
                    case 3:
                        result = _b.sent();
                        this.setState({
                            validations: result.validations,
                            pageValidations: result.pageValidations
                        });
                        validationFailures = [];
                        for (_i = 0, _a = Object.keys(result.validations); _i < _a.length; _i++) {
                            question = _a[_i];
                            validationResult = result.validations[question];
                            if (validationResult && !validationResult.valid) {
                                validationFailures.push(question.toString());
                            }
                        }
                        if (!(result.pageValidations.some(function (val) { return val.valid === false; }) || validationFailures.length > 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.commandsExecutor.executeJourneyEvent("onValidateFail", this.pageContext)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [4 /*yield*/, this.commandsExecutor.executeJourneyEvent("onAfterValidate", this.pageContext)];
                    case 6:
                        _b.sent();
                        return [2 /*return*/, Promise.resolve(result.valid)];
                }
            });
        });
    };
    /**
     * Navigates to specific page in a journey
     * @param pageId
     * @param validate
     * @param fireEvents
     * @param reload
     */
    PluginJourneyRenderingPage.prototype.navigate = function (pageId, validate, fireEvents, reload) {
        if (validate === void 0) { validate = true; }
        if (fireEvents === void 0) { fireEvents = true; }
        if (reload === void 0) { reload = false; }
        return __awaiter(this, void 0, void 0, function () {
            var isValid, _a, _b, journeyManager, p, _c, uri;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!validate) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validate()];
                    case 1:
                        _a = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = true;
                        _d.label = 3;
                    case 3:
                        isValid = _a;
                        if (!(this.state && this.state.journey && isValid)) return [3 /*break*/, 8];
                        _b = fireEvents;
                        if (!_b) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.commandsExecutor.executePageEvent("onAfterValidate", this.pageContext)];
                    case 4:
                        _b = (_d.sent());
                        _d.label = 5;
                    case 5:
                        _b;
                        journeyManager = new JourneyManager_1.JourneyManager(this.state.journey);
                        p = journeyManager.fetchPage(pageId);
                        // Trigger event
                        _c = fireEvents;
                        if (!_c) 
                        // Trigger event
                        return [3 /*break*/, 7];
                        return [4 /*yield*/, this.commandsExecutor.executeJourneyEvent("onPageChange", this.pageContext)];
                    case 6:
                        _c = (_d.sent());
                        _d.label = 7;
                    case 7:
                        // Trigger event
                        _c;
                        uri = "/journey/show/product/".concat(this.props.match.params["product"], "/process/").concat(this.props.match.params["process"], "/").concat(pageId).concat(this.state.interaction && this.state.interaction._id ? "/" + this.state.interaction._id : "");
                        if (reload) {
                            window.location.href = uri;
                        }
                        else {
                            this.props.history.push(uri);
                            this.setState({
                                page: p
                            });
                        }
                        _d.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates interaction with new value. Must be new interaction object. Should only be used with latest interaction.
     */
    PluginJourneyRenderingPage.prototype.callInteractionSetState = function (interaction, after) {
        this.setState({ interaction: interaction }, after);
        this.rendererServices.updateInteraction(interaction);
    };
    PluginJourneyRenderingPage.prototype.getInteraction = function () {
        return this.state.interaction;
    };
    PluginJourneyRenderingPage.prototype.toggleOverlay = function (showOverlay, eventId) {
        if (showOverlay) {
            PluginJourneyRenderingPage.overlayEvents.push(eventId);
        }
        else {
            PluginJourneyRenderingPage.overlayEvents = PluginJourneyRenderingPage.overlayEvents.filter(function (x) { return x !== eventId; });
        }
        this.setState({
            showOverlay: PluginJourneyRenderingPage.overlayEvents.length > 0
        });
    };
    PluginJourneyRenderingPage.prototype.validateQuestion = function (questionName) {
        return __awaiter(this, void 0, void 0, function () {
            var questions, question, value, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        questions = this.pageValidator.getQuestionsToValidate(this.pageContext.interaction, {
                            journey: this.pageContext.journey,
                            page: this.pageContext.page
                        });
                        question = questions.find(function (q) { return q.name === questionName; });
                        if (!question) return [3 /*break*/, 2];
                        value = journey_services_1.ObjectManipulator.fetchFieldValue(question.interactionField, this.pageContext.interaction);
                        return [4 /*yield*/, this.questionValidator.validate(value, {
                                journey: this.pageContext.journey,
                                page: this.pageContext.page,
                                question: question,
                                interaction: this.pageContext.interaction,
                                engine: this
                            })];
                    case 1:
                        result = _a.sent();
                        this.handleValidation(questionName, result);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.renderJourneyLoader = function (journeyLoaded, serviceError) {
        return (React.createElement(components_1.Spinner, { show: (!journeyLoaded) && !serviceError }));
    };
    PluginJourneyRenderingPage.prototype.determineProduct = function () {
        return this.getPathParam("product");
    };
    PluginJourneyRenderingPage.prototype.determinePrcess = function () {
        return this.getPathParam("process");
    };
    PluginJourneyRenderingPage.prototype.getPathParam = function (name) {
        var match = this.props.match;
        if (match && match.params && match.params[name]) {
            return match.params[name];
        }
        return null;
    };
    PluginJourneyRenderingPage.prototype.processJourneyLoadError = function (product, process, interactionId) {
        this.props.history.push("/journey/init/product/".concat(product, "/process/").concat(process));
    };
    /**
     * If layout defined for page or journey - renders page in specific layout
     * Otherwise renders page only
     */
    PluginJourneyRenderingPage.prototype.renderLayout = function () {
        var layoutId = this.state.page.layoutId || this.state.journey.layoutId;
        if (layoutId) {
            // Layout defined for page or journey - render specific layout
            var layoutComponent = this.journeyComponentsManager.fetchLayoutComponent(layoutId);
            if (!layoutComponent) {
                throw new Error("Cannot find layout: ".concat(layoutId));
            }
            return React.createElement(layoutComponent.component, __assign(__assign({}, this.pageContext), { children: this.renderNavigator() }));
        }
        else {
            // Layout not defined
            return this.renderNavigator();
        }
    };
    /**
     * Renders journey navigator
     */
    PluginJourneyRenderingPage.prototype.renderNavigator = function () {
        var navigatorType = this.state.page.navigatorType || this.state.journey.navigatorType;
        if (navigatorType) {
            var navigator_1 = this.journeyComponentsManager.fetchNavigatorComponent(navigatorType);
            if (!navigator_1) {
                throw new Error("Cannot find navigator: ".concat(navigatorType));
            }
            return React.createElement(navigator_1.component, __assign(__assign({}, this.pageContext), { children: this.renderQuestions() }));
        }
        else {
            return React.createElement(React.Fragment, __assign(__assign({}, this.pageContext), { children: this.renderQuestions() }));
        }
    };
    /**
     * Renders page questions
     */
    PluginJourneyRenderingPage.prototype.renderQuestions = function () {
        return React.createElement(QuestionList_1.QuestionList, __assign({}, this.pageContext, { questions: this.state.page.questions, onStateChange: this.handleStateChange, onValidate: this.handleValidation }));
    };
    PluginJourneyRenderingPage.prototype.decidePageToRender = function (journey) {
        var pageId = null;
        var match = this.props.match;
        if (match && match.params && match.params["pageId"]) {
            pageId = match.params["pageId"];
        }
        var journeyManager = new JourneyManager_1.JourneyManager(journey);
        if (pageId) {
            var page = journeyManager.fetchPage(pageId);
            if (page) {
                return page;
            }
        }
        return journeyManager.fetchEntryPage();
    };
    PluginJourneyRenderingPage.prototype.setUserReference = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        user = this.applicationGuard && this.applicationGuard.getUser();
                        if (!(user && !(this.state.interaction && user.id === this.state.interaction.userReference))) return [3 /*break*/, 2];
                        this.setState({
                            interaction: __assign(__assign({}, this.state.interaction), { userReference: user.id })
                        });
                        return [4 /*yield*/, this.executeOnLoadEvents()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.authorizationRequired = function () {
        var journey = this.state.journey;
        return ((journey && journey.protected) || (this.applicationGuard &&
            (this.journeyRuntimeServiceConfig.authMandatory || this.applicationGuard.isAuthenticated())));
    };
    PluginJourneyRenderingPage.prototype.executeOnLoadEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event = {
                            type: "onLoad"
                        };
                        return [4 /*yield*/, this.commandsExecutor.executeJourneyEvent("onPageLoad", this.pageContext)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.commandsExecutor.executeNativePageEvent(event, this.pageContext)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.handleStateChange = function (field, value) {
        var _this = this;
        var currentValue = journey_services_1.ObjectManipulator.fetchFieldValue(field, this.state.interaction);
        var initialValue = journey_services_1.ObjectManipulator.fetchFieldValue(field, this.state.initialInteraction);
        if (this.state.typingTimeout > 0 && currentValue) {
            clearTimeout(this.state.typingTimeout);
            var timeout = process.env.REACT_APP_INTERACTION_UPDATE_TIMEOUT ? parseInt(process.env.REACT_APP_INTERACTION_UPDATE_TIMEOUT, 10) : 0;
            var newInteraction_1 = __assign({}, this.state.interaction);
            journey_services_1.ObjectManipulator.setField(field, newInteraction_1, value);
            this.setState({
                typingTimeout: setTimeout(function () {
                    _this.trackChangesAndUpdateInteraction(newInteraction_1, field, currentValue, value, initialValue);
                }, timeout)
            });
        }
        else {
            this.handleImmediateStateChange(field, value);
        }
    };
    PluginJourneyRenderingPage.prototype.handleImmediateStateChange = function (field, value) {
        var newInteraction = __assign({}, this.state.interaction);
        var currentValue = journey_services_1.ObjectManipulator.fetchFieldValue(field, this.state.interaction);
        var initialValue = journey_services_1.ObjectManipulator.fetchFieldValue(field, this.state.initialInteraction);
        journey_services_1.ObjectManipulator.setField(field, newInteraction, value);
        this.trackChangesAndUpdateInteraction(newInteraction, field, currentValue, value, initialValue);
    };
    PluginJourneyRenderingPage.prototype.trackChangesAndUpdateInteraction = function (newInteraction, field, currentValue, newValue, initialValue) {
        var _this = this;
        if (newValue === currentValue) {
            return;
        }
        var uistate = newInteraction.uistate;
        // uistate.trackChanges should be explicitly set in journey page to enable change tracking. It is not persisted to Mongo.
        if (uistate === null || uistate === void 0 ? void 0 : uistate.trackChanges) {
            this.trackChanges(uistate, field, initialValue, newValue);
        }
        this.callInteractionSetState(newInteraction, function () {
            if (!field.startsWith("uistate.")) {
                _this.commandsExecutor.executeJourneyEvent("onInteractionChange", _this.pageContext);
            }
        });
    };
    /*
     * Update array uistate.changes which records all fields that have been modified since saving interaction.
     * Set uistate.interactionChangesDetected accordingly.
     */
    PluginJourneyRenderingPage.prototype.trackChanges = function (uistate, field, initialValue, newValue) {
        if (!field.startsWith("uistate.")) {
            if (!uistate.changes) {
                uistate.changes = [];
            }
            var changes = uistate.changes;
            if (String(initialValue) !== String(newValue)) {
                if (!changes.includes(field)) {
                    changes.push(field);
                }
            }
            else {
                var index = changes.indexOf(field);
                if (index !== -1) {
                    changes.splice(index, 1);
                }
            }
            uistate.interactionChangesDetected = (changes.length === 0);
        }
    };
    PluginJourneyRenderingPage.prototype.handleValidation = function (field, result) {
        var validations = this.state.validations;
        validations[field] = result;
        this.setState({
            validations: validations
        });
    };
    PluginJourneyRenderingPage.prototype.loadJourney = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, match, intl, product, process, interactionId, journeyDefinitionObservable, interactionObservable;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.props, match = _a.match, intl = _a.intl;
                this.setState({
                    journeyLoaded: false
                });
                product = this.determineProduct();
                process = this.determinePrcess();
                if (product == null || process == null) {
                    throw new Error("Action, product or process not specified.");
                }
                if (match && match.params && match.params["interactionId"]) {
                    interactionId = match.params["interactionId"];
                }
                journeyDefinitionObservable = this.loadJourneyDefinition(product, process, intl.locale, interactionId);
                interactionObservable = this.loadInteraction(product, process, interactionId);
                interactionObservable.toPromise().then(function (interaction) {
                    _this.setState({
                        product: product,
                        process: process,
                        interaction: interaction,
                        initialInteraction: (0, lodash_1.cloneDeep)(interaction)
                    });
                    return journeyDefinitionObservable.toPromise();
                }).then(function (journey) {
                    var page = _this.decidePageToRender(journey);
                    _this.setState({
                        page: page,
                        journeyLoaded: true,
                        validations: {},
                        pageValidations: [],
                        journey: journey
                    });
                    _this.rendererServices.journeyReady(_this.state.product, _this.state.process, journey);
                }).catch(function (err) {
                    _this.processJourneyLoadError(product, process, interactionId);
                });
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    PluginJourneyRenderingPage.prototype.switchLanguage = function (locale) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, product, process, interaction, journeyDefinition, page;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state, product = _a.product, process = _a.process, interaction = _a.interaction;
                        this.setState({
                            journeyLoaded: false
                        });
                        return [4 /*yield*/, this.loadJourneyDefinition(product, process, locale, interaction._id).toPromise()];
                    case 1:
                        journeyDefinition = _b.sent();
                        page = this.decidePageToRender(journeyDefinition);
                        this.setState({
                            page: page,
                            journeyLoaded: true,
                            journey: journeyDefinition
                        });
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.loadJourneyDefinition = function (product, process, locale, interactionId) {
        return interactionId ?
            this.journeyRuntimeService.getJourneyDefinition(product, process, locale, interactionId) :
            this.journeyRuntimeService.getJourneyDefinition(product, process, locale);
    };
    PluginJourneyRenderingPage.prototype.loadInteraction = function (product, process, interactionId) {
        if (interactionId) {
            return this.propositionEngine
                .fetchInteraction(product, interactionId)
                .pipe((0, operators_1.map)(function (int) {
                return __assign(__assign({}, int), { process: process, product: product });
            }));
        }
        else {
            var user = this.applicationGuard && this.applicationGuard.getUser();
            return (0, rxjs_1.of)({
                product: product,
                process: process,
                // On navigation bettween journey defs which are authorized, authorize component is not rerendered and on authorize hook is not called
                userReference: user && user.id
            });
        }
    };
    PluginJourneyRenderingPage.prototype.mountLeaveAlert = function () {
        var _this = this;
        var page = this.state.page;
        if (page && page.onLeaveAlert) {
            // Window exit reload
            window.onbeforeunload = function (event) {
                return window.confirm(page.onLeaveAlert);
            };
            // React router dom route change
            this.unblockRoute = this.props.history.block(function (location) {
                _this.props.history;
                if (location.key && _this.state.journey.pages.filter(function (e) { return location.pathname.indexOf(e.pageId) !== -1; }).length === 0) {
                    return page.onLeaveAlert;
                }
                return;
            });
        }
    };
    PluginJourneyRenderingPage.prototype.unmountLeaveAlert = function () {
        this.unblockRoute && this.unblockRoute();
        window.onbeforeunload = function () { return undefined; };
    };
    PluginJourneyRenderingPage.prototype.handleKeyDown = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandsExecutor.executeNativePageEvent(event, this.pageContext)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.prototype.handleSubmit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.commandsExecutor.executeNativePageEvent(event, this.pageContext)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PluginJourneyRenderingPage.overlayEvents = [];
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.JourneyRendererServices),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "rendererServices", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "journeyRuntimeService", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.PropositionEngine),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "propositionEngine", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.PageValidator),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "pageValidator", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.QuestionValidator),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "questionValidator", void 0);
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.JourneyComponentsManager),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "journeyComponentsManager", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.CommandsExecutor),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "commandsExecutor", void 0);
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        (0, core_1.optional)(),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "applicationGuard", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.RuntimeServiceConfig),
        __metadata("design:type", Object)
    ], PluginJourneyRenderingPage.prototype, "journeyRuntimeServiceConfig", void 0);
    return PluginJourneyRenderingPage;
}(React.Component));
exports.PluginJourneyRenderingPage = PluginJourneyRenderingPage;
var LocalizablePluginJourneyRenderingPage = (0, react_intl_1.injectIntl)(PluginJourneyRenderingPage);
exports.LocalizablePluginJourneyRenderingPage = LocalizablePluginJourneyRenderingPage;
//# sourceMappingURL=PluginJourneyRenderingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/pages/PluginJourneyRenderingPage.js
// module id = 959
// module chunks = 0